import { render, staticRenderFns } from "./RegularPrognoseLayer.vue?vue&type=template&id=536c95b4&"
import script from "./RegularPrognoseLayer.vue?vue&type=script&lang=js&"
export * from "./RegularPrognoseLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports